<template>
  <div class="building-wrapper">
    <app-markets-nav :navItems="navItems"></app-markets-nav>
    <div class="building-content">

      <h4 class="building-h4 indent" id="building-overview">СТРОИТЕЛСТВО И АРХИТЕКТУРА</h4>
      <p class="building-p indent">Алуминият се отличава с разнообразни приложения в сферата на строителството и съвременната архитектура. Това е предпочитаният материал за вентилируеми фасади, дограми и други стъклени конструкции. Той намира широко приложение при производството на ролетни щори, интериорни и входни врати, фасадни обшивки и покривни елементи, окачени тавани, панели и преградни стени, вентилационни и климатични системи, слънцезащитни системи, светлоотражатели и дори напълно сглобяеми конструкции.
      </p>
      <p  class="building-p indent">Конструкции от рода на офшорни платформи, хеликоптерни площадки, парапети, строителни скелета и стълби също често биват произвеждани от алуминиеви продукти.</p>
      <p class="building-p indent">Алкомет произвежда профили по чертеж на клиента за Вашите архитектурни системи, както и богата гама от валцови продукти с приложения в строителството – листа, ленти и фолио.</p>
      <p  class="building-p indent">Изпратете ни Вашето запитване още днес.</p>

      <div class="building-img" :style="{backgroundImage: 'url(' + '/static/img/markets/building/img_1.jpg' + ')'}"></div>
      <h4 class="building-h4 indent" id="building-facades">ФАСАДИ</h4>
      <p class="building-p indent">Фасадата е най-важният елемент от естетическото и техническото изпълнение на една сграда. Алуминият дава на съвременните архитекти нужната свобода по отношение на дизайна, като същевременно позволява адаптиране към разнообразните и променящи се изисквания на потребителите в различните страни по света.</p>
      <p class="building-p indent">Алуминиевите профили в комбинация със стъкло са идеални за осигуряване максимален достъп на естествена светлина в сградите.</p>
      <p class="building-p indent">Окачените фасади обикновено са система от алуминиеви профили, стъкло и други композитни материали, оформящи една олекотена конструкция.</p>
      <p class="building-p indent">Окачените фасадни системи се използват при всички видове сгради, благодарение на редица предимства: кратко време за монтаж, ниска себестойност поради ниско тегло и висока устойчивост. Алуминият е най-подходящият материал за подобряване енергийната ефективност на фасадните системи, тъй като позволява максимално проникване на слънчева светлина и редуцира разходите за отопление и охлаждане.</p>
      <p class="building-p indent">Интелигентните фасади с алуминиеви конструкции могат да подобрят енергийната ефективност на сградите с до 50%. Тяхна основна отличителна черта е оптимизираното взаимодействие с външната среда, което рязко намалява консумацията на енергия за отопление, охлаждане, вентилация и осветление през цялата година.</p>

      <div class="building-img" :style="{backgroundImage: 'url(' + '/static/img/markets/building/img_2.jpg' + ')'}"></div>
      <h4 class="building-h4 indent" id="building-wad">ВРАТИ И ПРОЗОРЦИ</h4>
      <p class="building-p indent">Алуминиевите прозорци имат редица предимства пред останалите. Устойчивост, лесна поддръжка, модерен външен вид с безкрайно разнообразие от цветове и отличната звукоизолация са само няколко от тях. Стъклопакетите с алуминиеви рамки предлагат на клиентите минималистични, тънки профили, които максимизират панорамната гледка – идеални за потребители, които искат да се наслаждават на естествените пейзажи.</p>
      <p class="building-p indent">Алуминиевите прозорци намаляват загубата на топлина с до 60%, когато се комбинират с термомост и постигат дори най-високите стандарти за енергийна ефективност, което ги прави предпочитан елемент в съвременната архитектура.</p>

      <div class="building-img" :style="{backgroundImage: 'url(' + '/static/img/markets/building/img_2.jpg' + ')'}"></div>
      <h4 class="building-h4 indent" id="building-blinds">РОЛЕТНИ ЩОРИ</h4>
      <p class="building-p indent">Алуминият осигурява изгоден висококачествен материал, който гарантира дълготрайност и по-дълъг живот на продукта. Той също така осигурява висока степен на прецизност при производството и висока издръжливост.</p>


      <div class="building-img" :style="{backgroundImage: 'url(' + '/static/img/markets/building/img_2.jpg' + ')'}"></div>
      <h4 class="building-h4 indent" id="building-interior">ИНТЕРИОРЕН ДИЗАЙН</h4>
      <p class="building-p indent">Алуминият е лек, устойчив, корозоустойчив, рециклируем до безкрай, може да се обработва във всякакви форми и благодарение на тези си свойства предлага архитектурни решения, непостижими с останалите строителни материали. В интериорното оформление той намира разнообразни приложения, като преградни стени, подови настилки, окачени тавани, мебели и др.</p>
      <p class="building-p indent">Алуминиевите преградни стени дават максимална гъвкавост при оформлението на съвременните офиси, давайки възможност на архитекти, строители и проектанти да променят из основи концепцията за работното място на бъдещето. Система от конструкции за преградни стени е идеалното решение за оформяне на помещения и обособяване на работни пространства.</p>
      <p class="building-p indent">Алуминиевите аксесоари за подови настилки са идеални за различни видове материали. Те се отличават с устойчивост на различно натоварване, напълно подходящи са за деликатни преходи между подови настилки на различни нива и придават елегантен вид на прехода между стени и подове, первази на врати и други елементи.
      </p>


      <app-share-button></app-share-button>
    </div>
  </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
import MarketsNav from "./MarketsNav";
export default {
  components: {
    appShareButton: ShareButton,
    appMarketsNav: MarketsNav
  },
  data() {
    return {
      navItems: [
        ["building-overview", "Строителство и архитектура"],
        ["building-facades", "Фасади"],
        ["building-wad", "Врати и прозорци"],
        ["building-blinds", "Ролетни щори"],
        ["building-interior", "Интериорен дизайн"]
      ]
    };
  }
};
</script>

<style scoped>
.building-wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
}
/* CONTENT */
.building-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 80%;
}
.building-p {
  font-size: 19px;
  margin: 15px 0;
  text-align: justify;
  line-height: 32px;
  width: 60%;
}
.building-h4 {
  font-size: 22px;
  font-weight: 500;
  line-height: 32px;
  margin: 15px 0;
  text-align: justify;
  width: 60%;
}
.building-img {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 5px;
  min-height: 500px;
  margin: 20px 0;
  width: 80%;
}
@media screen and (max-width: 1000px) {
  .building-content {
    width: 100%;
  }
  .building-h4 {
    font-size: 18px;
    padding: 0 30px;
    width: 100%;
  }
  .building-p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .building-img {
    background-attachment: fixed;
    border-radius: 0;
    min-height: 30vw;
    margin: 20px 30px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/markets/Building.vue